import styled from 'styled-components';

export const Container = styled.span`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding-left: 5px;
  position: relative;
`;

export const DownArrow = styled.div`
  position: relative;
  top: 5px;
  left: -1px;
`;
